<script setup lang="ts">
import { connectStats } from 'instantsearch.js/es/connectors';
import {
  StatsConnectorParams,
  StatsWidgetDescription,
} from 'instantsearch.js/es/connectors/stats/connectStats';
import { computed } from 'vue';
// @ts-expect-error (function lacks types; this should be converted in the near future)
import { createSuitMixin } from 'vue-instantsearch/vue3/es';

import { useWidget } from '@/composables/instant-search/useWidget';

defineOptions({
  mixins: [createSuitMixin({ name: 'Stats' })],
});

const { state } = useWidget<StatsWidgetDescription, StatsConnectorParams>(
  { connector: connectStats },
  computed(() => ({})),
);

const hitsPerPage = computed(() => state.value?.hitsPerPage);
const nbHits = computed(() => state.value?.nbHits);
const page = computed(() => state.value?.page);

const paginatedCountBeginning = computed(() => {
  if (!hitsPerPage.value || page.value === undefined) return 0;
  return hitsPerPage.value * (page.value + 1) - hitsPerPage.value + 1;
});
const paginatedCountEnd = computed(() => {
  if (!hitsPerPage.value || page.value === undefined || !nbHits.value) return 0;
  return hitsPerPage.value * (page.value + 1) > nbHits.value
    ? nbHits.value
    : hitsPerPage.value * (page.value + 1);
});
</script>

<template>
  <div v-if="state" class="paginated-results-count" :class="suit()">
    <slot v-bind="state" :results="state.instantSearchInstance.helper?.lastResults">
      <span :class="suit('text')" data-test="stats-text-bottom"
        >Showing {{ paginatedCountBeginning }}-{{ paginatedCountEnd }} of {{ nbHits }}</span
      >
    </slot>
  </div>
</template>
